/**
 * lp-analytics.js
 *
 * Fires client-side Meta Pixel `AddToCart` and GA4 `add_to_cart` events
 * from the theme-dispatched `cart:update` event. Generates a UUID per
 * event and writes it to `event.detail.data.eventId` so Elevar can read
 * the same ID server-side for CAPI / Measurement Protocol dedup.
 *
 * SHIPS OFF BY DEFAULT — controlled by window.LP_ANALYTICS_ENABLED.
 * Each LP buy-box section sets the flag to true from Liquid when its
 * `enable_client_side_analytics` setting is on. Without the dedup wiring
 * on Elevar's side, double-firing would pollute CAC + ROAS metrics
 * (Elevar already fires both events server-side).
 *
 * Each platform call is wrapped in try/catch so a broken Pixel doesn't
 * break the next event.
 */
(() => {
  const generateEventId = () => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    return Date.now() + '-' + Math.random().toString(36).slice(2, 11);
  };

  document.addEventListener('cart:update', (event) => {
    if (window.LP_ANALYTICS_ENABLED !== true) return;

    const detail = event.detail || {};
    const data = detail.data || {};
    const resource = detail.resource || {};

    const variantId = data.variantId;
    if (!variantId) return;

    const eventId = generateEventId();
    data.eventId = eventId;

    const items = Array.isArray(resource.items) ? resource.items : [];
    const matchedItem = items.find((item) => String(item.variant_id) === String(variantId))
      || items[items.length - 1];
    const valueCents = matchedItem ? Number(matchedItem.line_price) || 0 : 0;
    const value = valueCents / 100;
    const currency = resource.currency
      || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      || 'USD';
    const itemCount = Number(data.itemCount) || 1;

    if (typeof window.fbq === 'function') {
      try {
        window.fbq('track', 'AddToCart', {
          content_ids: [String(variantId)],
          content_type: 'product_variant',
          value,
          currency,
        }, { eventID: eventId });
      } catch (error) {
        console.error('[lp-analytics] fbq AddToCart failed', error);
      }
    }

    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', 'add_to_cart', {
          currency,
          value,
          items: [{
            item_id: String(variantId),
            quantity: itemCount,
            price: value,
          }],
          event_id: eventId,
        });
      } catch (error) {
        console.error('[lp-analytics] gtag add_to_cart failed', error);
      }
    }
  });
})();
